import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { decryptUrlData } from "../../helpers/Reusable";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import DOMPurify from "dompurify";

const PracticeArticleDetails = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let decryptedData = decryptUrlData(queryParams.get("gcc"));
  const { topicId } = decryptedData;
  const printRef = useRef();
  const [isShowInIframe, setIsShowInIframe] = useState(true);
  const [topic, setTopic] = useState({});

  // Topic Details API Call
  const viewTopicDetails = async (topicId) => {
    const param = {
      practisetopicId: topicId,
    };
    var response = await postData(
      "practise/user/detail",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setTopic(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewTopicDetails(topicId);
  }, [topicId]);

  const handlePrint = (ref, fileName = "Print") => {
    if (!ref.current) return;

    const printContents = ref.current.cloneNode(true); // Clone content
    const printIframe = document.createElement("iframe");

    // Hide the iframe
    printIframe.style.position = "absolute";
    printIframe.style.width = "0";
    printIframe.style.height = "0";
    printIframe.style.border = "none";

    document.body.appendChild(printIframe);

    const originalTitle = document.title;
    document.title = fileName;

    printIframe.contentDocument.open();
    printIframe.contentDocument.write(`
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            @page { margin: 0; }
          </style>
        </head>
        <body>
          <div id="print-content" class="print-container"></div>
        </body>
      </html>
    `);
    printIframe.contentDocument.close();

    const appendContentAndPrint = () => {
      const printContentDiv =
        printIframe.contentDocument.getElementById("print-content");
      if (!printContentDiv) {
        document.body.removeChild(printIframe);
        document.title = originalTitle;
        return;
      }

      printContentDiv.appendChild(printContents);

      printIframe.contentWindow.focus();
      printIframe.contentWindow.print();

      printIframe.contentWindow.onafterprint = () => {
        document.body.removeChild(printIframe);
        document.title = originalTitle;
        setIsShowInIframe(true);
      };

      // Fallback cleanup
      setTimeout(() => {
        if (printIframe.parentNode) {
          document.body.removeChild(printIframe);
          document.title = originalTitle;
          setIsShowInIframe(true);
        }
      }, 5000);
    };

    if (printIframe.contentDocument.readyState === "complete") {
      appendContentAndPrint();
    } else {
      printIframe.contentWindow.onload = appendContentAndPrint;
    }
  };

  return (
    <div className="w-full p-[5%] bg-yellow min-h-screen">
      <div className="xxl:container mx-auto">
        <div className="w-full">
          <div className="w-full flex justify-between gap-10 mb-10 items-start">
            <h1 className="practice-topic-title">{topic?.topicName}</h1>
            {topic?.isPrintable && (
              <button
                onClick={() => handlePrint(printRef, topic?.topicName)}
                className="w-max px-[2rem] py-[.5rem] btn-print"
              >
                Print
              </button>
            )}
          </div>
          <div
            ref={printRef}
            className="break-words practice-desc"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(topic?.topicDetail) || "",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PracticeArticleDetails;
